import React from 'react';
import { useApp } from '../context/AppContext';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function Toast() {
  const { notifications } = useApp();

  return (
    <div className="fixed top-20 left-0 right-0 z-50 flex flex-col items-center pointer-events-none space-y-2 px-4">
      <AnimatePresence>
        {notifications.map((notif) => (
          <motion.div
            key={notif.id}
            initial={{ opacity: 0, y: -20, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9, transition: { duration: 0.2 } }}
            className={`flex items-center space-x-2 px-4 py-3 rounded-lg shadow-lg border pointer-events-auto w-full max-w-sm ${
              notif.type === 'success' 
                ? 'bg-emerald-900/90 border-emerald-800 text-emerald-100'
                : 'bg-slate-800 border-slate-700 text-slate-100'
            }`}
          >
            <SafeIcon 
              icon={notif.type === 'success' ? FiIcons.FiCheckCircle : FiIcons.FiInfo} 
              className={notif.type === 'success' ? 'text-emerald-400' : 'text-slate-400'}
            />
            <span className="text-sm font-medium">{notif.message}</span>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}